import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Select, InputLabel, MenuItem } from "@material-ui/core";
import Checkbox from "../../../Common/CustomCheckbox";
import t from "../../../../languages/pl";

const useStyles = theme => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        minWidth: 150,
        marginTop: theme.spacing(0.5)
    },
    checkbox: {
        color: "grey",
        padding:0,
        marginRight: theme.spacing(1)
    },
    selectDay: {
        minWidth: 50,
    },
    selectMonth: {
        minWidth: 110,
    },
    formControl: {
        marginLeft: theme.spacing(1)
    }
});

const months = [t.january, t.february, t.march, t.april, t.may, t.june, t.july,
                t.august, t.september, t.october, t.november, t.december];

const days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

const TireChangeDate = props => {
    const { classes, label, day, month, onDayChange, onMonthChange, selected, onSelect } = props;
    let i = 0;

    return (
        <div className={classes.container}>
            <Checkbox
                className={classes.checkbox}
                checked={selected}
                onChange={(e) => onSelect(e.target.checked)}
            />
            <div className={classes.formControl}>
                <InputLabel
                    shrink={true}
                >
                    {label}
                </InputLabel>
                <Select
                    className={classes.selectDay}
                    defaultValue=""
                    value={(selected && day !== 0) ? day : ""}
                    disabled={!selected}
                    onChange={(e) => onDayChange && onDayChange(e.target.value)}
                >
                    <MenuItem value=""><em>{t.pick}</em></MenuItem>
                    {days.map(day => <MenuItem key={day} value={day}>{day}.</MenuItem>)}
                </Select>
                <Select
                    className={classes.selectMonth}
                    defaultValue=""
                    value={(selected && month !== 0) ? month : ""}
                    disabled={!selected}
                    onChange={(e) => onMonthChange && onMonthChange(e.target.value)}
                >
                    <MenuItem value=""><em>{t.pick}</em></MenuItem>
                    {months.map(month => <MenuItem key={i++} value={i}>{month}</MenuItem>)}
                </Select>
            </div>

        </div>
    );
};

TireChangeDate.propTypes = {
    classes: PropTypes.object,
    label: PropTypes.string,
    day: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    month: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onDayChange: PropTypes.func,
    onMonthChange: PropTypes.func,
    selected: PropTypes.bool,
    onSelect: PropTypes.func
};

export default withStyles(useStyles)(TireChangeDate);
